// extracted by mini-css-extract-plugin
export default {"title":"gYoQdBG","count":"fzzLG_y"};